@if (isAutorized()) {
  <app-token-expiration-check [secTimer]="60" [refreshSessionAble]="true" [minSessionDurationSec]="600" [autoRefreshAble]="false"></app-token-expiration-check>
  <app-side-nav-outer-toolbar title="{{appInfo.title}}">
    <router-outlet></router-outlet>
    <app-footer>
      Developed by Il Dato SRL
    </app-footer>
  </app-side-nav-outer-toolbar>
} @else {
  <app-not-authorized-container></app-not-authorized-container>
}

